import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import React from 'react';
import Button from '../Shared/components/controls/Button';

const Card = ({ data, theme }) => {
  const { heading, image, logo, primaryButton, secondaryButton, text, doubleSize } = data;

  const shouldRenderHeading = !!heading?.value;
  const shouldRenderImage = !!image?.value?.src;
  const shouldRenderLogo = !!logo?.value?.src;
  const shouldRenderPrimaryButton = !!primaryButton?.value?.href;
  const shouldRenderSecondaryButton = !!secondaryButton?.value?.href;
  const shouldRenderText = !!text?.value;

  return (
    <div className={clsx('sub-card', theme, doubleSize?.value && 'double-size')}>
      {shouldRenderImage && (
        <div className="sub-card-image">
          <Image field={image} />
        </div>
      )}
      {shouldRenderLogo && (
        <div className="sub-card-logo">
          <Image field={logo} />
        </div>
      )}
      <div className="card-overlay"></div>
      <div className="sub-card-content">
        {shouldRenderHeading && (
          <h3>
            <Text field={heading} />
          </h3>
        )}
        {shouldRenderText && <RichText className="sub-card-text" field={text} />}
        {shouldRenderPrimaryButton && (
          <Button link={primaryButton} className="sub-card-link sub-card-primary-link" />
        )}
        {shouldRenderSecondaryButton && (
          <Button link={secondaryButton} className="sub-card-link sub-card-secondary-link" />
        )}
      </div>
    </div>
  );
};

export default Card;
